import { useQuery } from "@tanstack/react-query";
import { AlarmTileType, AlarmData } from "src/features/dashboard/components/tiles/alarmTile/types";
import { dashboardBFF } from "../axios-instances";
import { getEnv } from "src/config/index";
import { useFeatureToggle } from "src/api/featureToggling/useGetFeatureToggle";
import { FeatureToggleKey } from "src/api";
import { getServices } from "src/logs";

const { logger } = getServices();

// tip for testing locally: you can set REACT_APP_BACKEND_URL=http://localhost:5000 in .env.development
const refreshInterval =
  getEnv().REACT_APP_BE_REFRESH_INTERVAL ||
  (() => {
    logger.logError({ message: "REACT_APP_BE_REFRESH_INTERVAL environmental variable not set" });
    throw new Error("REACT_APP_BE_REFRESH_INTERVAL environmental variable not set");
  })();

export const getAlarms =
  (types: AlarmTileType[], logsDetailedFeature?: boolean | undefined) => async () => {
    try {
      const uri = `/api/alarms/count?api-version=2.0&alertTypes=${types.join(",")}`;

      // if ((process.env.REACT_APP_ENVIRONMENT || "").toLowerCase() === "development") {
      //   console.log("---getAlarms:", uri);
      // }

      const response = await dashboardBFF.get(uri, { timeout: 3000 });

      const alarmCountResult = response.data as AlarmData;

      if (logsDetailedFeature) {
        logger.logTrace({
          message: "getConsumptionOverviewData - response",
          properties: {
            type: response.data.type,
            count: response.data.count
          }
        });
      }
      return alarmCountResult;
    } catch (error) {
      const err = error as Error;
      if (!err.message.includes("204")) {
        logger.logError({
          message: "getAlarms - Exception",
          properties: {
            name: err.name,
            message: err.message,
            stack: err.stack || "unknown stack",
            cause: String(err.cause ?? "unknown cause")
          }
        });
      }
      throw error;
    }
  };

export const UseGetAlarmData = (alertTypes: AlarmTileType[]) => {
  const { data: logsDetailedFeature } = useFeatureToggle(FeatureToggleKey.LogsDetailed);

  return useQuery<AlarmData, Error>({
    queryKey: ["alarmData", alertTypes],
    queryFn: getAlarms(alertTypes, logsDetailedFeature?.isEnabled),
    refetchOnWindowFocus: false,
    retry: 3, // Retry 3 times
    retryDelay: 3000, // Wait 3 seconds between each retry (in milliseconds)
    refetchInterval: parseInt(refreshInterval)
  });
};

